import { Module, VuexModule, getModule, MutationAction } from 'vuex-module-decorators';
import store from '~common-store';
import { AppState } from '~common-interfaces/app.interface';

@Module({ dynamic: true, store, name: 'app', namespaced: true })
class App extends VuexModule implements AppState {
    adminApp = '';

    @MutationAction
    async setAdminApp(adminApp: string) {
        return { adminApp };
    }

}

export const AppModule = getModule(App);
